import { createAction } from '@reduxjs/toolkit';

import { Room, TableItem } from '../types';

export const roomOpen = createAction<{
	roomId?: string | number;
}>('room/open');
export const roomClose = createAction('room/close');
export const roomLoaded = createAction<Room>('room/loaded');
export const roomError = createAction<string>('room/error');

export const tablesSet = createAction<TableItem[]>('room/tables/set');
export const tablesAppend = createAction<TableItem[]>('room/tables/append');
// Table ids are v2 uuids on the wire (v1's were numeric) — keep them as-is and
// compare as strings; numeric coercion turned every uuid into NaN and the
// seat-count updates silently never matched a table.
export const tablesUpdateSeats = createAction<{ id: string | number; inc: boolean }>(
	'room/tables/updateSeats',
);
export const tablesRemove = createAction<string | number>('room/tables/remove');
